const deployStatuses = {
	PENDING: 'PENDING',
	ONGOING: 'ONGOING',
	SUCCESS: 'SUCCESS',
	FAILED: 'FAILED',
	STOPPED: 'STOPPED',
};

module.exports = deployStatuses;
